import { api } from "@api/api";
import { Banner } from "@modules/banners/types";
import { BannerFormValues } from "@modules/banners/validations";

export async function editBannerService(id: string, data: Partial<BannerFormValues>): Promise<Banner> {
  const { image, image_mobile, ...body } = data;
  const payload = !image ? { ...body, image: null } : body;

  const { data: banner } = await api.patch<Banner>(`v1/banner_admin/${id}/`, payload);

  if (image && image instanceof File || image_mobile && image_mobile instanceof File) {
    const formData = new FormData();
    formData.append("image", image);
    formData.append("image_mobile", image_mobile);

    const { data: banner } = await api.patch<Banner>(`v1/banner_admin/${id}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return banner;
  }

  return banner;
}
